export const ROOT_CATEGORY_ID = "root";